import React, { useState, useEffect } from "react";
import DOMPurify from "dompurify"; // Import DOMPurify
import { checkAndInitializeDB, saveToDB, getFromDB } from "../../../component/indexedDB/indexedDB"; // Adjust the import path as necessary
import QuestionPublicLink from "../../../component/PublicLink/PublicLink";
import {
  QuizDescription,
  QuizTitle,
  QuizScreen,
  QuizForm,
  QuizFormVertical,
  QuizButton,
  QuizTextArea,
  QuizMessage,
  QuizMessageMedia,
  QuizDescriptionDiv,
  QuizTextInputField, // Import the new styled component
} from "../../GeneralStyles";
import { CloseButton, QuizMessagePopUp } from "../../../component/modal/QuizMessagePopUp";
import QuizMarkdown from "../../../component/Markdown/QuizMarkdown";

const QuestionOpen = ({ question, overViewPage, enableNavigationButton }) => {
  const [answer, setAnswer] = useState("");
  const [message, setMessage] = useState(null);
  const [messageMedia, setMessageMedia] = useState(null); // New state for media
  const [attempts, setAttempts] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    const dbName = sessionStorage.getItem("currentSessionName") || "Leerling";
    checkAndInitializeDB(dbName);
    if (dbName !== "Leerling") {
      getFromDB(dbName).then((data) => {
        const attemptData = data.find(
          (item) => item.id === question.quiz_item_id
        );
        if (attemptData) {
          setAttempts(attemptData.attempts || 0);
          if (attemptData.answer) {
            setAnswer(attemptData.answer);
            enableNavigationButton(); // Enable navigation if there's already an answer
          }
          if (
            question.maximum_attempts > 0 &&
            attemptData.attempts >= question.maximum_attempts
          ) {
            setIsDisabled(true);
          }
        }
      });
    }
  }, [question.quiz_item_id, question.maximum_attempts]);

  const handleClosePopup = () => {
    setMessage(null);
    setMessageMedia([]);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const dbName = sessionStorage.getItem("currentSessionName") || "Leerling";
    if (
      question.maximum_attempts > 0 &&
      attempts >= question.maximum_attempts
    ) {
      setMessage(
        DOMPurify.sanitize("Je hebt het maximale aantal pogingen bereikt.")
      );
      setMessageMedia(null); // No media for this message
      return;
    }

    setMessage(DOMPurify.sanitize(question.general_succes_text));
    setMessageMedia(question.general_succes_media); // Set success media

    const attempt = {
      id: question.quiz_item_id,
      answer,
      success: true,
      attempts: attempts + 1,
    };
    saveToDB([attempt], dbName);
    setAttempts(attempts + 1);

    if (
      question.maximum_attempts > 0 &&
      attempts + 1 >= question.maximum_attempts
    ) {
      setIsDisabled(true);
    }

    enableNavigationButton();
  };

  // Helper function to render media based on mime type
  const renderMedia = (mediaItems) => {
    if (!mediaItems || mediaItems.length === 0) return null;

    return (
      <QuizMessageMedia>
        {mediaItems.map((media) => {
          if (media.mime && media.mime.startsWith("image/")) {
            return (
              <img
                style={{ width: "50px" }}
                key={media.id}
                src={media.url}
                alt={media.name || "media"}
              />
            );
          } else if (media.mime && media.mime.startsWith("audio/")) {
            return <audio key={media.id} autoPlay src={media.url} />;
          } else if (media.embed) {
            return (
              <div
                key={media.id}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(media.embed),
                }}
              />
            );
          } else {
            return null;
          }
        })}
      </QuizMessageMedia>
    );
  };

  return (
    <QuizScreen
      bgColor={question.theme_color}
      bgVisible={overViewPage}
      id={question.quiz_item_id}
    >
      <QuestionPublicLink
        overViewPage={overViewPage}
        type="question"
        quiz_item_id={question.quiz_item_id}
      />
      <QuizTitle>{question.title}</QuizTitle>
      <QuizDescriptionDiv><QuizMarkdown>{question.description}</QuizMarkdown></QuizDescriptionDiv>
      <QuizForm onSubmit={handleSubmit}>
        <QuizFormVertical>
        {question.quiz_line_count === "multi_line" &&(
          <QuizTextArea
            value={answer}
            borderColor={question.theme_color}
            onChange={(e) => setAnswer(e.target.value)}
            maxLength={question.maximum_characters}
            rows='2'
            disabled={isDisabled}
          ></QuizTextArea>
        )}
        {question.quiz_line_count === "single_line" &&(
          <QuizTextInputField
            value={answer}
            type="text"
            borderColor={question.theme_color}
            onChange={(e) => setAnswer(e.target.value)}
            maxLength={question.maximum_characters}
            disabled={isDisabled}
          ></QuizTextInputField>
        )}
          {question.show_submit_button !== false && (
            <QuizButton
              type="submit"
              bgColor={question.theme_color}
              txtColor={question.theme_text_color}
              disabled={isDisabled}
            >
            {question.submit_button_text}
          </QuizButton>)}
          {(message || (messageMedia && messageMedia.length > 0)) && (
            <QuizMessagePopUp>
               <CloseButton onClick={handleClosePopup} aria-label="Close Popup">&times;</CloseButton>
              {/* Render Media First */}
              {renderMedia(messageMedia)}
              {/* Updated QuizMessage to render sanitized HTML */}
              <QuizMessage className="message">
                <QuizMarkdown>{message}</QuizMarkdown>
              </QuizMessage>
            </QuizMessagePopUp>
          )}
        </QuizFormVertical>
      </QuizForm>
    </QuizScreen>
  );
};

export default QuestionOpen;
